module.exports = __webpack_public_path__ + "static/media/logo.63b3038a.png";